/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { typeof as _typeof } from '../../../../_virtual/_rollupPluginBabelHelpers.js';

var _isEqual = function isEqual(itemA, itemB) {
  if (itemA && itemB) {
    if (Array.isArray(itemA) && Array.isArray(itemB)) {
      // array size not equal
      if (itemA.length !== itemB.length) {
        return false;
      }
      return !itemA.some(function (item, index) {
        if (!_isEqual(item, itemB[index])) {
          return true;
        }
        return false;
      });
    }
    if (_typeof(itemA) === 'object' && _typeof(itemB) === 'object') {
      return !Object.keys(itemA).some(function (key) {
        if (!_isEqual(itemA[key], itemB[key])) {
          return true;
        }
        return false;
      });
    }
  }
  return itemA === itemB;
};
var isEqual = _isEqual;

export { isEqual as default };
